import React from 'react';
import ReactDOM from 'react-dom';
import { GTM_CODE } from 'constants/env';
import './index.sass';
import './theme/theme.scss';
import './theme/sears-theme.sass';
import TagManager from 'react-gtm-module';
import App from './App';

const tagManagerArgs = {
  gtmId: GTM_CODE,
  dataLayerName: 'PageDataLayer',
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
// serviceWorker.register();
